import { initDevTools } from './devtools';

initDevTools();




// WEBPACK FOOTER //
// devtools/index.js